import {createSlice} from '@reduxjs/toolkit';

// ---- import from local actions ----
import {fetchRoleSelection, fetchRoleList} from './../actions/RoleActions';


const RoleSlice = createSlice({
  name: 'role',
  initialState: {
    roleSelection: {
      data: [],
      status: 'idle',
      error: '',
      loading: false,
    },
    roleList: {
      data: [],
      status: 'idle',
      error: '',
      loading: false,
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchRoleSelection.pending, (state) => {
        state.roleSelection.status = 'loading';
      })
      .addCase(fetchRoleSelection.fulfilled, (state, action) => {
        state.roleSelection.status = 'idle';
        state.roleSelection.data = action.payload.result;
      })
      .addCase(fetchRoleSelection.rejected, (state, action) => {
        state.roleSelection.status = 'rejected';
        state.roleSelection.error = action.error.message;
      })

      .addCase(fetchRoleList.pending, (state) => {
        state.roleList.status = 'loading';
      })
      .addCase(fetchRoleList.fulfilled, (state, action) => {
        state.roleList.status = 'idle';
        state.roleList.data = action.payload.result;
      })
      .addCase(fetchRoleList.rejected, (state, action) => {
        state.roleList.status = 'rejected';
        state.roleList.error = action.error.message;
      });
  },
});


export default RoleSlice.reducer;
